
@if (isModal) {
  <ion-header>
    <ion-toolbar>
      <ion-back-button slot="start" text="" (click)="closeModal()"></ion-back-button>
      <ion-title>Kalender</ion-title>
    </ion-toolbar>
  </ion-header>
}

@if (generalSrv.serverVersionGreaterThan('1.11.0')) {
  <ion-content id="desktop" [class.sidebar-hidden]="!showSidebar">
    <calandar-sidebar [style.top.px]="isModal ? 55 : 0" [isModal]="isModal" [state]="showSidebar" (stateChanged)="showSidebar = $event" (datesChanged)="datesChanged($event)" (employeesChanged)="employeesChanged($event)"></calandar-sidebar>
    <section class="calendar-view">
      @if (selectedEmployees.length == 0) {
        <div class="no-content">Kein Mitarbeiter ausgewählt</div>
      }
      @if (selectedDates.length == 1 && selectedEmployees.length > 0) {
        <calandar-day-view [employees]="selectedEmployees" [appointments]="appointments" [date]="selectedDates[0]"></calandar-day-view>
      }
      @if (selectedDates.length > 1 && selectedDates.length <= 14 && selectedEmployees.length > 0) {
        <calandar-week-view [employees]="selectedEmployees" [appointments]="appointments" [dates]="selectedDates"></calandar-week-view>
      }
      @if (selectedDates.length > 14 && selectedEmployees.length > 0) {
        <calandar-month-view [employees]="selectedEmployees" [appointments]="appointments" [dates]="selectedDates"></calandar-month-view>
      }
    </section>
  </ion-content>
}


@if (!generalSrv.serverVersionGreaterThan('1.11.0')) {
  <ion-content class="ion-padding">
    <div class="incorrect-server">
      <h1>Um den Kalender nutzen zu können, muss der Server mindestens die Version 1.11.0 haben.</h1>
    </div>
  </ion-content>
}
